import { GenericLazyString, gettext } from '@eventbrite/i18n';

const SOCIAL_ERROR_DEFAULT_MESSAGE = gettext(
    'Whoops! Someone must have pulled a plug somewhere... try again.',
);

const SOFT_ACCOUNT_ERROR_MESSAGE = gettext(
    "You haven't set a password for your account. Continue as a guest for now, then add a password after you check out.",
);

export const SOCIAL_ERROR_MESSAGES: Record<string, GenericLazyString> = {
    DEFAULT: SOCIAL_ERROR_DEFAULT_MESSAGE,
    EMAIL_PERMISSION_DENIED: gettext(
        'The email address associated with your Facebook account could not be retrieved. Try again and grant access to email permissions or add an email to your social account.',
    ),
    EXTERNAL_USER_EMAIL_ALREADY_USED: SOCIAL_ERROR_DEFAULT_MESSAGE,
    EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT: SOFT_ACCOUNT_ERROR_MESSAGE,
    EXTERNAL_USER_UNKNOWN: SOFT_ACCOUNT_ERROR_MESSAGE,
    EXTERNAL_USER_WITHOUT_EMAIL: SOCIAL_ERROR_DEFAULT_MESSAGE,
    INVALID_SOCIAL_LOGIN_FIELD: SOCIAL_ERROR_DEFAULT_MESSAGE,
    STAFF_USER_NOT_ALLOWED: gettext(
        'Login during checkout is not available for admin users',
    ),
    SUSPENDED_ACCOUNT: gettext('Your Account has been locked.'),
    TOKEN_NOT_AUTHORIZED: SOCIAL_ERROR_DEFAULT_MESSAGE,
    USER_ALREADY_HAS_EXTERNAL_PROVIDER: gettext(
        'The user has already linked a Social account. To continue, sign in with your Eventbrite account and unlink it manually.',
    ),
};

export const GOOGLE_SIGNIN_METHOD = 'google_login';
